import React from 'react';
import classNames from "classnames";

export function TabList({ className = "", children }) {
    return (
        <ul className={classNames("tabs", className)}>{children}</ul>
    );
}
